'use client'

import { format } from 'date-fns'

type DateClientProps = {
  date: string | null | undefined
  formatPattern?: string
}

export default function DateClient({ date, formatPattern = 'd MMM HH:mm' }: DateClientProps) {
  return <>{date ? format(new Date(date), formatPattern) : '-'}</>
}
